const NO_CARD_PLANS = new Set(['buyer', 'referral', 'seller'])
const ACTIVE_STRIPE_STATUSES = new Set(['active', 'trialing', 'past_due', 'paused', 'unpaid'])

export function getEffectivePlanExpiryDate(user) {
  if (!user) return null
  const stripeStatus = (user.stripeSubscriptionStatus || user.stripe_subscription_status || '')
    .toString()
    .trim()
    .toLowerCase()
  const stripePeriodEnd = user.stripeCurrentPeriodEnd || user.stripe_current_period_end
  if (ACTIVE_STRIPE_STATUSES.has(stripeStatus) && stripePeriodEnd) {
    return stripePeriodEnd
  }
  return user.planExpiryDate || user.plan_expiry_date || null
}

/**
 * The API serializes plan_expiry_date as a naive-UTC ISO string (no Z/offset).
 * `new Date('2026-08-03T12:00:00')` would parse that as *local* time, skewing
 * the gate by the user's UTC offset — so treat zone-less timestamps as UTC.
 */
function parseUtcTimestamp(value) {
  if (value instanceof Date) return value.getTime()
  const s = String(value).trim()
  const isDateTime = /^\d{4}-\d{2}-\d{2}T\d{2}:/.test(s)
  const hasZone = /(Z|[+-]\d{2}:?\d{2})$/i.test(s)
  return new Date(isDateTime && !hasZone ? `${s}Z` : s).getTime()
}

export function hasActivePlan(userPlan, planExpiryDate, hasStripeCustomer) {
  const normalizedPlan = (userPlan || '').toString().trim().toLowerCase()
  if (normalizedPlan === 'infinite') return true
  if (!normalizedPlan || !planExpiryDate) return false

  const expiryMs = parseUtcTimestamp(planExpiryDate)
  if (Number.isNaN(expiryMs) || expiryMs <= Date.now()) return false

  return hasStripeCustomer || NO_CARD_PLANS.has(normalizedPlan)
}
